
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2960_8508)"}},[_c('rect',{attrs:{"width":"40","height":"40","rx":"4","fill":"#BB6BD9"}}),_c('g',{attrs:{"clip-path":"url(#clip1_2960_8508)","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M26.576 22.815l2.564 2.564-2.564 2.564M26.576 12.558l2.564 2.565-2.564 2.564"}}),_c('path',{attrs:{"d":"M29.14 15.124h-4.488c-3.205 0-5.769 5.128-5.769 5.128s2.564 5.129 5.77 5.129h4.487M18.883 20.25H9.91"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2960_8508"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_2960_8508"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(9.268 9.996)","d":"M0 0h20.513v20.513H0z"}})])])])
          )
        }
      }
    